module.exports = __webpack_public_path__ + "static/media/process_white.e9569574.svg";